import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import AdminScorecardSource from 'sources/scorecards/AdminScorecardSource';

class AdminScorecardActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions(
        'fetchAllScorecards',
        'fetchScorecard',
        'createScorecard',
        'updateScorecard'
      )
    );
  }
  fetchAllScorecards() {
    return dispatch => {
      dispatch();
      return AdminScorecardSource.fetchAll().then(
        this.fetchAllScorecardsSuccess,
        this.fetchAllScorecardsError
      );
    };
  }
  fetchScorecard(id) {
    return dispatch => {
      dispatch();
      return AdminScorecardSource.fetch(id).then(
        this.fetchScorecardSuccess,
        this.fetchScorecardError
      );
    };
  }
  createScorecard(scorecard) {
    return dispatch => {
      dispatch();
      return AdminScorecardSource.create(scorecard).then(
        this.createScorecardSuccess,
        this.createScorecardError
      );
    };
  }
  updateScorecard(scorecard) {
    return dispatch => {
      dispatch();
      return AdminScorecardSource.update(scorecard).then(
        this.updateScorecardSuccess,
        this.updateScorecardError
      );
    };
  }
}

export default alt.createActions(AdminScorecardActions);
